/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
import XButton from "vux/src/components/x-button/index.vue";
export default {
  name: 'LoadingButton',
  components: {
    XButton: XButton
  },
  props: {
    type: {
      type: String,
      default: 'primary'
    },
    method: {
      type: Function,
      default: function _default() {
        return void 0;
      }
    },
    exam: {
      type: [Function, null],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false
    };
  },
  methods: {
    func: function func() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var flag;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                flag = true;

                if (!_this.exam) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return _this.exam();

              case 4:
                flag = _context.sent;

              case 5:
                if (!flag) {
                  _context.next = 10;
                  break;
                }

                _this.loading = true;
                _context.next = 9;
                return _this.method();

              case 9:
                setTimeout(function () {
                  _this.loading = false;
                }, 1000);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};